module.exports = __webpack_public_path__ + "static/img/recreation.74f9a68a.png";